<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import { BFormTextarea } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData, ITextareaColumn } from '../types';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
  autofocus?: boolean;
}>();
const emit = defineEmits(['update:modelValue', 'change']);
const inputRef = ref<any>(null);

const col = computed(() => props.column as ITextareaColumn);

const currentValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const rows = computed(() => col.value.rows || 3);

onMounted(() => {
  if (props.autofocus && inputRef.value) {
    const el = inputRef.value;
    if (el.element && el.element.focus) {
      el.element.focus();
    } else if (el.focus) {
      el.focus();
    }
  }
});
</script>

<template>
  <BFormTextarea
    ref="inputRef"
    v-model="currentValue"
    size="sm"
    :name="col.name"
    :placeholder="col.placeholder"
    :rows="rows"
    :disabled="col.editorIsDisabled ? col.editorIsDisabled(row) : false"
    @change="emit('change', currentValue)"
    @click.stop
    @keydown.stop
  />
</template>
